<script setup>
import { inject } from 'vue';

const store = inject('store');
</script>

<template>
  <router-link to="/" class="navbar-brand text-light fs-1 fw-bold text-uppercase">
    <span class="">{{ store.state.brand.part1 }}&nbsp;</span> 
    <span>{{ store.state.brand.part21 }}</span>
    <span class="text-burlywood">{{ store.state.brand.part22 }}</span>
    <span>{{ store.state.brand.part23 }}&nbsp;</span>
    <span class="">{{ store.state.brand.part3 }}&nbsp;</span>
    <span class="text-burlywood">{{ store.state.brand.part4 }}</span>
  </router-link>

  <div class="d-flex flex-column text-uppercase text-secondary">
    <span class="fs-3 fw-bold">{{ store.state.brand.caption }}</span>
    <span class="fs-6">{{ store.state.brand.levels }}</span>
  </div>
</template>